"use client";
import "/src/styles/MoyaserStyles.css";
import { decryptPaymentData } from "@/utils/helpers";

import { useEffect } from "react";

const MoyasarForm = ({
  paymentData,
  // paymentMethod,
}: {
  paymentData: string | null;
  // paymentMethod: string | null;
}) => {
  useEffect(() => {
    if (!paymentData) return;
    const script = document.createElement("script");
    script.src = "https://cdn.moyasar.com/mpf/1.14.0/moyasar.js";
    script.async = true;
    script.onload = async () => {
      if (window.Moyasar) {
        const data = await decryptPaymentData(paymentData);
        window.Moyasar.init({
          element: ".mysr-form",
          ...data
        });
      }
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [
    paymentData,
    //  paymentMethod
    ]);

  return (
    <div className="mysr-form mx-auto  rounded-lg bg-gray-100 p-4 shadow-md"></div>
  );
};

export default MoyasarForm;
